import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// ---
// Services
// ---

import { MouseService } from '.';
export class MouseModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  providers: [MouseService],
  declarations: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MouseModule_tsickle_Closure_declarations() {
/** @type {?} */
MouseModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MouseModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
